import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getBybetjenter as getBybetjenterAction } from "../../../actions/bybetjenterActions";
import { getBybetjentGrupper } from "../../../actions/bybetjentgrupperAction";
import {
  handleChange as handleChangeAction,
  handleChangeAll as handleChangeAllAction,
  handleChangeToInitState as handleChangeToInitStateAction,
} from "../../../actions/handleChangeAction";
import { getSkiftlogger as getSkiftloggerAction } from "../../../actions/skiftloggerActions";

import { getSelectOptionsEnhanced } from "../../../selectors/selectOptionsSelector";

import * as inputValidation from "../../../utils/inputValidationUtils";

import { toIsoString } from "../../../utils/date";
import SkiftloggFilterForm from "./SkiftloggFilterForm";

function SkiftloggFilterContainer() {
  const dispatch = useDispatch();
  const SkiftloggFilterFormState = useSelector(
    (state) => state.forms.SkiftloggFilterForm,
  );
  const teams = useSelector((state) =>
    getSelectOptionsEnhanced(state, "betjentgrupper", "navn", "id"),
  );
  const bybetjenter = useSelector((state) =>
    getSelectOptionsEnhanced(state, "bybetjenter", "nummer", "nummer"),
  );

  const [showSokSpinner, setShowSokSpinner] = useState(false);

  // On mount, read search params and initialize form state if present
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const fraDato = searchParams.get("fraDato");
    const tilDato = searchParams.get("tilDato");
    let hasAny = false;
    const updates = {};
    if (fraDato) {
      updates.fraDato = fraDato;
      hasAny = true;
    }
    if (tilDato) {
      updates.tilDato = tilDato;
      hasAny = true;
    }
    if (hasAny) {
      Object.entries(updates).forEach(([key, value]) => {
        dispatch(handleChangeAction("SKIFTLOGG_FILTER_FORM", key, value));
      });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    dispatch(getBybetjentGrupper());
    dispatch(getBybetjenterAction({ onlyActive: true }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeLocal = (e) => {
    dispatch(
      handleChangeAction(
        "SKIFTLOGG_FILTER_FORM",
        e.target.name,
        e.target.value,
      ),
    );
  };

  const handleChangeToInitStateLocal = () => {
    dispatch(handleChangeToInitStateAction("SKIFTLOGG_FILTER_FORM"));
  };

  const validate = () => {
    return inputValidation.fraDateTimeTilDateTimeValidation(
      SkiftloggFilterFormState,
      (name, value) =>
        dispatch(handleChangeAction("SKIFTLOGG_FILTER_FORM", name, value)),
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setShowSokSpinner(true);
      const params = {
        fraDato: toIsoString(SkiftloggFilterFormState.fraDato),
        tilDato: toIsoString(SkiftloggFilterFormState.tilDato),
        teamIds: SkiftloggFilterFormState.selectedTeams.map((team) => team.id),
        tjenestenummer: SkiftloggFilterFormState.selectedTjenestenummer.map(
          (tjenestenummer) => tjenestenummer.id,
        ),
      };
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set("fraDato", params.fraDato);
      searchParams.set("tilDato", params.tilDato);
      window.history.replaceState(
        null,
        "",
        window.location.pathname + "?" + searchParams.toString(),
      );
      dispatch(getSkiftloggerAction(params))
        .then(() => {
          setShowSokSpinner(false);
          dispatch(
            handleChangeAllAction("RAPPORT_SKIFTLOGG_SUBMITTED_FORM", {
              submitTimestamp: new Date(),
              fraDato: SkiftloggFilterFormState.fraDato,
              tilDato: SkiftloggFilterFormState.tilDato,
              teams: SkiftloggFilterFormState.selectedTeams
                .map((team) => team.navn)
                ?.toString(),
              tjenestenummer: SkiftloggFilterFormState.selectedTjenestenummer
                .map((tjenestenummer) => tjenestenummer.id)
                ?.toString(),
            }),
          );
        })
        .catch(() => setShowSokSpinner(false));
    }
  };

  return (
    <SkiftloggFilterForm
      showSokSpinner={showSokSpinner}
      skiftloggFilterFormState={SkiftloggFilterFormState}
      bybetjenter={bybetjenter}
      teams={teams}
      handleChange={handleChangeLocal}
      handleChangeToInitState={handleChangeToInitStateLocal}
      handleSubmit={handleSubmit}
    />
  );
}

SkiftloggFilterContainer.propTypes = {
  SkiftloggFilterFormState: PropTypes.object,
  bybetjenter: PropTypes.arrayOf(PropTypes.object),
  teams: PropTypes.array,
};

export default SkiftloggFilterContainer;
